var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiumultiline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.1484H0V18.0004H24V17.1484Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20358 17.8354L2.57031 17.3132L11.9789 4.32835L16.7092 10.0033L22.6284 0V17.5744H21.8143V2.96804L16.8255 11.4186L12.0178 5.67491L3.20358 17.8354Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7466 12.6172H5.94531V17.5913H6.7466V12.6172Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53176 10.3438H7.73047V17.5714H8.53176V10.3438Z",
    fill: "#383838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2739 7.92578H9.47266V17.5718H10.2739V7.92578Z",
    fill: "#383838"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0044 5.53516H11.2031V17.572H12.0044V5.53516Z",
    fill: "#383838"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7505 6.62109H12.9492V17.5726H13.7505V6.62109Z",
    fill: "#383838"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4966 8.70312H14.6953V17.5797H15.4966V8.70312Z",
    fill: "#383838"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2271 10.6094H16.4258V17.576H17.2271V10.6094Z",
    fill: "#383838"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9849 7.62891H18.1836V17.5772H18.9849V7.62891Z",
    fill: "#383838"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.731 4.69922H19.9297V17.5742H20.731V4.69922Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiumultiline);
export default __webpack_public_path__ + "static/media/biểu đồ multi line.a9990d4db41911876563ec6304705487.svg";
export { ForwardRef as ReactComponent };